import React, { useState, useContext, ChangeEvent, useMemo } from "react";
import Snackbar from "@material-ui/core/Snackbar";
import Alert from "@material-ui/lab/Alert";
import { useHistory } from "react-router-dom";
import moment from "moment";

import * as Components from "./components";
import * as Contexts from "../../contexts";
import * as Buttons from "../../components/Buttons";
import * as Page from "../../components/Page";

import { SInitialForm } from "./static";
import { TCoordinates, TForm } from "./types";
import { config, Translater } from "../../config";
import { IRestaurant, TWorkingTime } from "../../types/items";
import { useHttp } from "../../hooks";
import { useValidation } from "../../hooks";
import { TabLanguage } from "../../components/TabLanguage";
import { Crop } from "react-image-crop";
import { WorkingTable } from "./components/WorkingTable/WorkingTable";

const allTimeFilled = (time: TWorkingTime | undefined) =>
  !!time && Object.values(time).every((day) => !!day.start && !!day.end);

const CreatePage: React.FC = () => {
  const { token } = useContext(Contexts.AuthContext);
  const { language } = useContext(Contexts.LanguageContext);

  const history = useHistory();
  const { loading, request } = useHttp();
  const [photo, setPhoto] = useState<File | null>(null);
  const [headerPhoto, setHeaderPhoto] = useState<File | null>(null);
  const [form, setForm] = useState<TForm>(SInitialForm);
  const [workingTime, setWorkingTime] = useState<TWorkingTime>();
  const [deliveryTime, setDeliveryTime] = useState<TWorkingTime>();

  const [value, setValue] = useState<{ value: string; lang: string }[]>([]);

  const [valueLang, setValueLang] = useState<string>(language.slug);
  const [isClicked, setIsClicked] = useState<boolean>(false);
  const [coordinates, setCoordinates] = useState<TCoordinates>({
    lat: "0",
    lon: "0",
  });

  const [metaKeywords, setMetaKeywords] = useState<string[]>([]);
  const [metaDescription, setMetaDescription] = useState<string>("");

  const [isAlertOpen, toogleIsAlertOpen] = useState<boolean>(false);

  const [crop, setCrop] = useState<Crop>({
    unit: "px", // Can be 'px' or '%'
    x: 25,
    y: 25,
    width: 350,
    height: 350,
  });

  const schema = useMemo<any>(
    () => ({
      title: {
        condition:
          form.title
            .map((item) => {
              if (!item.value) {
                return false;
              }
              return true;
            })
            .filter((item) => item).length == 2,
        error: `
          ${Translater.ErrorLanguage[language.slug]}:
          ${Translater.TableTitles.title[language.slug]}`,
      },
      photo: {
        condition: photo !== null,
        error: `
        ${Translater.ErrorPhoto[language.slug]}:
        ${Translater.TableTitles.phone[language.slug]}`,
      },
      phone: {
        condition: !!form.phone,
        error: `
          ${Translater.ErrorLength[language.slug]}:
          ${Translater.TableTitles.phone[language.slug]}`,
      },
      // email: {
      //   condition: !!form.email,
      //   error: `
      //     ${Translater.ErrorLength[language.slug]}:
      //     ${Translater.TableTitles.email[language.slug]}`,
      // },
      value: {
        condition: !!value,
        error: `
          ${Translater.ErrorAddress[language.slug]}:
          ${Translater.TableTitles.address[language.slug]}`,
      },
      workingTime: {
        condition: allTimeFilled(workingTime),
        error: `
        ${Translater.TableTitles.errorWorkingTime[language.slug]}:
        ${Translater.TableTitles.workTime[language.slug]}
      `,
      },
      deliveryTime: {
        condition: allTimeFilled(deliveryTime),
        error: `
        ${Translater.TableTitles.errorWorkingTime[language.slug]}:
        ${Translater.TableTitles.orderAcceptTime[language.slug]}
      `,
      },
    }),
    [
      form.title,
      form.phone,
      language.slug,
      photo,
      value,
      workingTime,
      deliveryTime,
    ]
  );
  const { errors, validationSchema, validation } = useValidation(schema);

  const Events = {
    inputHandler: (e: ChangeEvent<HTMLInputElement>) => {
      if (e.target.name === "title") {
        const isTitleInArr = form.title.find((item) => item.lang == valueLang)
          ? true
          : false;

        if (isTitleInArr) {
          const title = form.title
            .map((item) => {
              if (item.lang == valueLang) {
                return { value: e.target.value, lang: valueLang };
              }
              return item;
            })
            .filter((item) => item.value);

          setForm({
            ...form,
            title: title as { value: string; lang: string }[],
          });

          return;
        }

        const title = form.title
          .concat({
            value: e.target.value,
            lang: valueLang,
          })
          .filter((item) => item.value);

        setForm({
          ...form,
          title: title as { value: string; lang: string }[],
        });

        return;
      }

      if (e.target.name === "photo") {
        setPhoto(e.target?.files?.length ? e.target?.files[0] : null);
      } else setForm({ ...form, [e.target.name]: e.target.value });
    },
    inputFileHandler: (e: ChangeEvent<HTMLInputElement>) => {
      setHeaderPhoto(e.target?.files?.length ? e.target?.files[0] : null);
    },
    selectHandler: (e: ChangeEvent<HTMLSelectElement>) => {
      setForm({ ...form, [e.target.name]: e.target.value });
    },
    createHandler: async () => {
      try {
        setIsClicked(true);
        await validation();
        await Callbacks.Create();
      } catch (e) {
        toogleIsAlertOpen(true);
        try {
          await validation();
          await Callbacks.Create();
        } catch (e) {
          toogleIsAlertOpen(true);
        }
      }
    },
  };

  const Callbacks = {
    Create: async () => {
      try {
        const {
          title,
          password,
          login,
          email,
          phone,
          facebook,
          telegram,
          instagram,
        } = form;

        const contacts: IRestaurant["contacts"] = {
          phone,
          email,
          social: {
            facebook,
            instagram,
            telegram,
          },
        };

        const data: FormData = new FormData();

        data.append("contacts", JSON.stringify(contacts));
        data.append("workingTime", JSON.stringify(workingTime));
        data.append("deliveryTime", JSON.stringify(deliveryTime));

        if (photo) data.append("mainImage", photo);

        data.append("metaDescription", metaDescription);
        if (metaKeywords.length) {
          metaKeywords.map((el) => data.append("metaKeywords[]", el));
        }

        headerPhoto && data.append("headerPhoto", headerPhoto);
        coordinates &&
          data.append(
            "coordinates",
            JSON.stringify({
              coordinates: [coordinates],
              type: "Point",
            })
          );
        data.append("title", JSON.stringify(form.title));
        data.append("headerColor", form.headerColor);
        if (password) data.append("password", password);
        if (login) data.append("login", login);

        const response = await request(
          `${config.API}/restaurants`,
          "POST",
          data,
          {
            Authorization: `Bearer ${token as string}`,
          }
        );

        if (response.title) {
          history.goBack();
        }
      } catch (e) {
        toogleIsAlertOpen(true);
      }
    },
  };

  return (
    <Page.Wrapper title={Translater.RestaurantsCreatePage.title[language.slug]}>
      <Page.Header
        backButtonTitle={Translater.RestaurantsCreatePage.title[language.slug]}
        backButtonLink="/restaurants"
      />

      <Buttons.Container
        disabled={loading}
        createHandler={Events.createHandler}
      />

      <TabLanguage setValueLang={setValueLang} valueLang={valueLang} />

      <Components.ConfigBlock
        isCreate
        address={value}
        metaKeywords={metaKeywords}
        setMetaKeywords={setMetaKeywords}
        metaDescription={metaDescription}
        setMetaDescription={setMetaDescription}
        form={form}
        photo={photo}
        isClicked={isClicked}
        headerPhoto={headerPhoto}
        inputHandler={Events.inputHandler}
        setForm={setForm}
        inputFileHandler={Events.inputFileHandler}
        valueLang={valueLang}
        setPhoto={setPhoto}
      />
      <div
        style={{
          maxWidth: "712px",
          display: "flex",
          gap: "20px",
          flexWrap: "wrap",
          justifyContent: "space-between",
        }}
      >
        <WorkingTable
          initialData={workingTime}
          setData={setWorkingTime}
          title={Translater.Landings.Banquet.workingHours[language.slug]}
        />
        <WorkingTable
          initialData={deliveryTime}
          setData={setDeliveryTime}
          title={Translater.TableTitles.orderAcceptTime[language.slug]}
        />
      </div>
      <Components.ContactsBlock
        address={value}
        form={form}
        setForm={setForm}
        setAddress={setValue}
        isClicked={isClicked}
        setCoordinates={setCoordinates}
        isValid={validationSchema}
        inputHandler={Events.inputHandler}
      />

      <Snackbar
        open={isAlertOpen}
        autoHideDuration={10000}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
        onClose={() => toogleIsAlertOpen(false)}
      >
        <Alert severity="error">
          {[...errors].map((error) => (
            <p key={`error-item-${error}`}>- {error}</p>
          ))}
        </Alert>
      </Snackbar>
    </Page.Wrapper>
  );
};

export default CreatePage;
